import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { BasicButton } from "components/buttons/basic-button";

export const AssistantComposer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 5),
  flexShrink: 0,
}));

export const AssistantInputRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-end",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.custom.semantic.border.default}`,
  borderRadius: theme.shape.borderRadius[2],
  backgroundColor: theme.palette.custom.semantic.surface.card,
  "&:focus-within": {
    borderColor: theme.palette.primary.main,
  },
}));

export const AssistantInputField = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  "& .MuiTextField-root": {
    height: "auto",
    borderRadius: 0,
    backgroundColor: "transparent",
  },
  "& .MuiInputBase-root": {
    padding: theme.spacing(1),
    ...theme.typography.subtitle7,
    color: theme.palette.primary.main,
  },
  "& .MuiInputBase-input::placeholder": {
    color: theme.palette.custom.semantic.text.muted,
    opacity: 1,
  },
}));

export const AssistantSendButton = styled(BasicButton)(({ theme }) => ({
  width: theme.spacing(7),
  minWidth: theme.spacing(7),
  height: theme.spacing(7),
  flexShrink: 0,
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius[2],
  boxShadow: "none",
}));

export const AssistantComposerHint = styled(Typography)(({ theme }) => ({
  display: "block",
  marginTop: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.custom.semantic.text.muted,
}));
